import React from "react";

export default function DetailItem({ title, value, dark = false, className = "" }) {
  return (
    <div className={`flex flex-col sm:flex-row sm:items-center justify-between p-4 rounded-xl border transition-all duration-300 ${
      dark 
        ? "bg-zinc-950/30 border-zinc-800/40 hover:border-zinc-700/50 hover:bg-zinc-900/20" 
        : "bg-gray-50/50 border-gray-100 hover:border-gray-200 hover:bg-gray-50"
    } ${className}`}>
      <dt className={`font-semibold text-xs sm:text-sm uppercase tracking-wider ${dark ? "text-zinc-400" : "text-gray-500"}`}>
        {title}
      </dt>
      <dd className={`text-sm sm:text-base font-medium mt-1 sm:mt-0 ${dark ? "text-zinc-200" : "text-gray-800"}`}>
        {value}
      </dd>
    </div>
  );
}

